import useSWR from 'swr'
import { useDataSearchApi } from '../useDataSearchApi'
import { DataSearchResultsViewModel, DocumentTypeV1, Guid } from 'api'
import { useAuth } from '../useAuth'

interface DataSearchResults {
  results: DataSearchResultsViewModel[] | undefined
  isLoading: boolean
  isError: any
}

export const useDataSearchResults = (
  customerAgencyId: Guid,
  searchValue: string,
  selectedType: DocumentTypeV1,
  requestedTime: number,
) => {
  const shouldFetch = customerAgencyId && searchValue !== ''
  const { performSearch } = useDataSearchApi()
  const { user } = useAuth()

  // useSWR is a caching library that will cache the results based on the key, and then refetch as needed
  // include the current user's id in the caching token for the api cache as well as the requestedTime
  const { data, error } = useSWR(
    shouldFetch
      ? [customerAgencyId, selectedType, searchValue, requestedTime, user?.id]
      : null,
    performSearch,
    {
      // by default it will refresh when you reconnect or refocus on the browser tab, but also set it to refresh every 30 seconds
      refreshInterval: 30000,
      errorRetryCount: 3,
      errorRetryInterval: 10000,
    },
  )

  const returnValue: DataSearchResults = {
    results: data,
    // we are not considered loading if we are showing them data, even if it is updating in the background
    isLoading: !error && !data && searchValue !== '',
    isError: error,
  }
  return returnValue
}
